<template>
  <div class="bg-gray-50 flex flex-col justify-between h-screen overflow-hidden relative p-6">
    <!-- Bouton plein écran -->
    <button 
      @click="toggleFullScreen"
      class="absolute top-6 right-6 bg-blue-600 hover:bg-blue-700 text-white py-2 px-3 rounded-lg shadow-lg transition duration-300 focus:outline-none"
      aria-label="Toggle Fullscreen"
    >
      <span v-if="isFullScreen">
        <i class="fa-solid fa-xmark text-xl"></i>
      </span>
      <span v-else>
        <i class="fa-solid fa-up-right-and-down-left-from-center text-sm"></i>
      </span>
    </button>

    <!-- Titre principal -->
    <h1 class="text-4xl font-bold text-center text-blue-600 mb-8">Liste d'attente des Patients</h1>

<!-- Liste des patients -->
<div class="grid gap-6 w-full overflow-y-auto pr-3" ref="patientsList" style="max-height: calc(100vh - 180px);" @scroll="checkOverflow">
  <div v-for="(chunk, index) in patientChunks" :key="index" class="bg-white shadow-sm rounded-lg divide-y divide-gray-200">
    <ul>
      <li v-for="(patient, i) in chunk" :key="'chunk-' + index + '-patient-' + i" class="py-5 px-6 flex justify-between items-center hover:bg-gray-100 transition">
        <span class="font-medium text-[3rem] text-gray-800">{{ patient.firstName }} {{ patient.lastName }}</span>
        <span v-if="patient.status === 'en cours'" class="text-green-600 font-semibold text-[3rem]">En cours</span>
      </li>
    </ul>
  </div>
  <!-- Afficher l'icône de défilement uniquement si il y a un overflow -->
  <div v-if="showArrow" class="animate-bounce absolute bottom-5 left-1/2 transform -translate-x-1/2">
    <i class="fa-solid fa-arrow-down text-3xl text-blue-600"></i>
  </div>
</div>



    <!-- Affichage en appel -->
    <div v-if="isCalling" class="absolute inset-0 bg-white flex items-center justify-center z-50">
      <h1 class="text-6xl md:text-8xl font-bold text-gray-900">{{ currentPatient.firstName }} {{ currentPatient.lastName }}</h1>
    </div>
     <!-- Animation de flèche lorsque plus de 10 patients -->

  </div>
</template>

  
  <script>
  export default {
    data() {
      return {
        showArrow: false,
        waitingPatients: [], // Tableau pour stocker les patients
        isFullScreen: false, // État pour savoir si le mode plein écran est activé
        isCalling: false, // État pour savoir si un appel est en cours
        currentPatient: {}, // Patient en cours d'appel
        qrCodeUrl: 'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=https://medecin.datafuse.fr/inscription',
        whiteBackground: false, // État pour gérer le fond blanc
        maxPatientsPerColumn: 0, // Déterminé dynamiquement
      };
    },
    computed: {
      sortedPatients() {
    // Créer une copie du tableau avant de le trier pour éviter des effets secondaires
    return [...this.waitingPatients].sort((a, b) => {
      // Comparaison des timeSlots
      return a.timeSlot.localeCompare(b.timeSlot);
    });
  },
  patientChunks() {
  console.log(this.waitingPatients);
  // Divise les patients en groupes en fonction du nombre maximal de patients par colonne
  if (this.maxPatientsPerColumn === 0) return [];

  const limitedPatients = this.sortedPatients.slice(0, 50); // ⬅️ Limite à 10 patients
  const chunks = [];

  for (let i = 0; i < limitedPatients.length; i += this.maxPatientsPerColumn) {
    chunks.push(limitedPatients.slice(i, i + this.maxPatientsPerColumn));
  }

  return chunks;
},

    getGridTemplateColumns() {
      // Ajuste dynamiquement le nombre de colonnes dans le grid
      return `repeat(${this.patientChunks.length}, minmax(0, 1fr))`; 
    },
  },
    methods: {
  checkOverflow() {
    const list = this.$refs.patientsList;
    if (!list) return;
    this.showArrow = list.scrollHeight > list.clientHeight;
}
,
      updateMaxPatientsPerColumn() {
      // Calcul dynamique du nombre maximal de patients par colonne en fonction de la hauteur de l'écran
      const rowHeight = 80; // Hauteur approximative d'un item (ajuster si nécessaire)
      const availableHeight = window.innerHeight - 200; // Ajuster pour prendre en compte les marges/paddings
      this.maxPatientsPerColumn = Math.floor(availableHeight / rowHeight);
    },
  
      fetchAppointments() {
        // Logique pour récupérer les rendez-vous de la journée
        fetch('https://thierry-paradis-medecin-743b8e1c5de0.herokuapp.com/appointments-today')
          .then(response => {
            if (!response.ok) {
              throw new Error('Erreur de réseau');
            }
            return response.json();
          })
          .then(data => {
            this.waitingPatients = data.filter(patient => patient.status !== 'terminé'); // Utiliser directement data
          })
          .catch(error => console.error('Erreur:', error));
      },
      setupWebSocket() {
    // Si la connexion WebSocket existe déjà, on la ferme avant de créer une nouvelle connexion.
    if (this.webSocket) {
        this.webSocket.close();
    }

    // Initialisation de la connexion WebSocket
    this.webSocket = new WebSocket('wss://thierry-paradis-medecin-743b8e1c5de0.herokuapp.com/ws'); 

    this.webSocket.onopen = () => {
        console.log('WebSocket connecté');

        // Envoie de messages "ping" toutes les 30 secondes pour garder la connexion active
        this.pingInterval = setInterval(() => {
            if (this.webSocket.readyState === WebSocket.OPEN) {
                this.webSocket.send(JSON.stringify({ type: 'ping' }));
            }
        }, 30000); // Intervalle de 30 secondes
    };

    this.webSocket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        console.log('Nouvelle donnée reçue:', message);

        if (message.type === 'appointmentUpdate') {
            this.fetchAppointments();
        } else if (message.type === 'call') {
            const patient = {
                firstName: message.appointment.firstName,
                lastName: message.appointment.lastName,
                id: message.appointment._id 
            };
            this.startCall(patient);
        } else if (message.type === 'statusUpdate') {
            this.updatePatientStatus(message.appointmentId, message.status);
        }
    };

    this.webSocket.onclose = () => {
        console.log('WebSocket déconnecté');
        
        // Nettoyer l'intervalle de ping lorsque la connexion est fermée
        clearInterval(this.pingInterval);
        
        // Tentative de reconnexion après une pause de 5 secondes
        setTimeout(() => {
            console.log('Tentative de reconnexion...');
            this.setupWebSocket();
        }, 5000); // Reconnexion après 5 secondes
    };

    this.webSocket.onerror = (error) => {
        console.error('Erreur WebSocket:', error);

        // Fermer la connexion en cas d'erreur et tenter une reconnexion
        this.webSocket.close();
    };
}
,
      updatePatientStatus(patientId, status) {
        // Met à jour le statut d'un patient dans la liste
        const patientIndex = this.waitingPatients.findIndex(patient => patient._id === patientId);
        if (patientIndex !== -1) {
          // Met à jour le statut
          this.waitingPatients[patientIndex].status = status; // Met à jour le statut directement

          // Si le statut est "terminé", on le retire du tableau
          if (status === 'terminé') {
            this.waitingPatients.splice(patientIndex, 1); // Supprime le patient de la liste
          }
        }
      },
      toggleFullScreen() {
        const element = document.documentElement;
        if (!document.fullscreenElement) {
          element.requestFullscreen().then(() => {
            this.isFullScreen = true; // Met à jour l'état pour le plein écran
          }).catch(err => console.log(`Erreur lors de l'entrée en plein écran: ${err.message}`));
        } else {
          document.exitFullscreen().then(() => {
            this.isFullScreen = false; // Met à jour l'état pour sortir du plein écran
          });
        }
      },
      startCall(patient) {
        // Met à jour les informations du patient en cours
        this.currentPatient = patient; // patient contient firstName, lastName, et id
        this.isCalling = true; // Afficher l'écran d'appel
        this.whiteBackground = true; // Afficher le fond blanc
  
        // Simuler la fin de l'appel après 15 secondes
        setTimeout(() => {
          this.isCalling = false; // Masquer après 15 secondes
          this.whiteBackground = false; // Masquer le fond blanc
        }, 15000); // Délai de 15 secondes
      }
    },
    mounted() {
      this.fetchAppointments(); // Récupérer les rendez-vous lors du montage du composant
      this.setupWebSocket(); // Établir la connexion WebSocket
      this.updateMaxPatientsPerColumn();
    window.addEventListener("resize", this.updateMaxPatientsPerColumn);
    this.$nextTick(() => {
    this.checkOverflow();
  });

    },
    watch: {
  patientChunks: {
    handler() {
      this.$nextTick(() => {
        this.checkOverflow();
      });
    },
    deep: true,
    immediate: true
  }
}

  };
</script>

  
  <style scoped>
  .qr-code {
    position: absolute;
    bottom: 20px; /* Ajustez selon vos besoins */
    right: 20px; /* Ajustez selon vos besoins */
  }
  
  .bg-white {
    background-color: white; /* Fond blanc */
  }
  </style>
  